import { gameDetailsReducer } from "@components/features/game-details/gameDetails.slice";
import { homeReducer } from "@components/features/home/home.slice";
import { LoaderSnackbarWrapperReducer } from "@components/organisms/LoaderSnackbarWrapper/LoaderSnackbarWrapper.slice";
import { configureStore } from "@reduxjs/toolkit";

export const store = configureStore({
  reducer: {
    user: homeReducer,
    globalAppearances: LoaderSnackbarWrapperReducer,
    selectedGame: gameDetailsReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
